export const chartColors = ['#b51f49', '#285075', '#755a00', '#6f4d74', '#006b5f', '#8b4a33', '#6c5d62'];
export const benchmarkColors = {
  station: '#b51f49',
  municipality: '#755a00',
  province: '#285075',
  region: '#6f4d74',
  country: '#23191c'
};
export const chartText = '#68575c';
export const chartGrid = '#eadde1';
export const chartSurface = '#fff8f9';
